var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('nuxt-link',{attrs:{"to":_vm.row.detailLocation}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-small text-muted"},[_vm._v("\n    "+_vm._s(_vm.row.imageDisplay)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }